export const WarningIcon = (props) => {
	const { className, size = 32, margin } = props;

	return (
		<img src="gif/attention.gif" width={size} height={size} className={className} style={{ margin }} />
	);
};